import type { ReactElement } from "react";
import React from "react";

export const CheckIcon = ({ className = "" }: { className?: string }): ReactElement => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <mask id="mask0_1701_1083" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.5" width="16" height="16" fill="white" />
      </mask>
      <g mask="url(#mask0_1701_1083)">
        <path
          d="M6.3666 10.6103L12.1089 4.86797C12.2495 4.72438 12.4165 4.65151 12.6099 4.64937C12.8032 4.64724 12.9739 4.71893 13.1217 4.86445C13.2696 5.00997 13.3435 5.17877 13.3435 5.37085C13.3435 5.56293 13.2696 5.7329 13.1217 5.88077L6.93838 12.0641C6.77545 12.229 6.58536 12.3115 6.36812 12.3115C6.15087 12.3115 5.95977 12.229 5.79481 12.0641L2.91148 9.18077C2.76789 9.04015 2.69674 8.87315 2.69801 8.67979C2.6993 8.48643 2.77271 8.31582 2.91823 8.16797C3.06375 8.0201 3.23255 7.94617 3.42463 7.94617C3.61671 7.94617 3.78668 8.0201 3.93453 8.16797L6.3666 10.6103Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
